import { getLecturerAvailabilityList } from "@/services/lecturer-availability.service";

import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  lecturerAvailabilityModel: {},
});

// mutations
const mutations = {
  setLecturerAvailabilityModel(state, data) {
    state.lecturerAvailabilityModel = data;
  },
};

// actions
const actions = {
  //Okutman Listesi
  async loadLecturerAvailabilityList(vuexContext, co) {
    return await getLecturerAvailabilityList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },
  addLecturerAvailabilityModel(vuexContext, data) {
    vuexContext.commit("setLecturerAvailabilityModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
